<div class="row">
    <div class="col">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Total Confirmed</h5>
                <p class="card-text"><strong>Note:</strong> Counts as per government records.</p>
                <div class="value font-weight--bold">
                    <strong>{{totalConfirmed}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Total Recovered</h5>
                <p class="card-text"><strong>Note:</strong> Counts as per government records.</p>
                <div class="value font-weight--bold">
                    <strong>{{totalRecovered}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Total Deaths</h5>
                <p class="card-text"><strong>Note:</strong> Counts as per government records.</p>
                <div class="value font-weight--bold">
                    <strong>{{totalDeaths}}</strong>
                </div>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="card">
            <div class="card-body">
                <h5 class="card-title">Total Active</h5>
                <p class="card-text"><strong>Note:</strong> Counts as per government records.</p>
                <div class="value font-weight--bold">
                    <strong>{{totalActive}}</strong>
                </div>
            </div>
        </div>
    </div>
</div>
